// Auth-bezogene Typen und Konstanten

export enum Rolle {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export interface AuthUser {
  id: number;
  username: string;
  email: string;
  vorname?: string;
  nachname?: string;
  rolle: Rolle;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string; // JWT oder undurchsichtiger Token
  user: AuthUser;
}

export interface AuthState {
  user: AuthUser | null;
  token: string | null;
}

export const AUTH_STORAGE_KEYS = {
  token: 'gks_auth_token',
  user: 'gks_auth_user',
};
